module.exports = __webpack_public_path__ + "media/images/common/scroll-307b47338707e1b47be3968d6ec66b7c.png";